import {
  Activity, BarChart2, Box, CheckCircle, DownloadCloud, FileText, Hash, Home, Layers, Link2, Mail,
  MessageSquare, PlayCircle, PlusSquare, Radio, RefreshCw, Search, Send, Server, Terminal, Users, AlertTriangle, BookOpen,
} from 'react-feather';

/**
 * Sidebar navigation per role. Paths are the existing routes, so bookmarks
 * and the links in export emails keep working.
 */
export const ADMIN_NAV = [
  {
    heading: null,
    items: [{ label: 'Overview', path: '/dashboard/home', icon: Home }],
  },
  {
    heading: 'Reports',
    items: [
      { label: 'Revenue', path: '/dashboard/report/summarize-report', icon: BarChart2 },
      { label: 'Revenue by product', path: '/dashboard/report/report-by-product', icon: Layers },
      { label: 'Subscriptions', path: '/dashboard/report/subscribers-list', icon: FileText },
      { label: 'Active subscribers', path: '/dashboard/report/active-list', icon: Users },
      { label: 'Telco traffic', path: '/dashboard/report/telco-report', icon: Radio },
      { label: 'Telco events', path: '/dashboard/report/events', icon: Activity, exact: true },
      { label: 'Sync failures', path: '/dashboard/report/partner-sync-failures', icon: AlertTriangle },
      { label: 'Exports', path: '/dashboard/report/events/exports', icon: DownloadCloud },
      { label: 'Email a report', path: '/dashboard/email-report', icon: Mail },
    ],
  },
  {
    heading: 'Partners & products',
    items: [
      { label: 'Partners', path: '/dashboard/usermanager', icon: Users, match: '/dashboard/usermanager' },
      { label: 'Products', path: '/dashboard/product/product-list', icon: Box },
      { label: 'New product', path: '/dashboard/product/create-product', icon: PlusSquare },
      { label: 'Partner shortcodes', path: '/dashboard/partner-shortcode', icon: Link2 },
    ],
  },
  {
    heading: 'Shortcodes & messages',
    items: [
      { label: 'Shortcodes', path: '/dashboard/shortcode/shortcode-list', icon: Hash },
      { label: 'Register a shortcode', path: '/dashboard/shortcode/subscribe', icon: PlusSquare },
      { label: 'Subscriber lookup', path: '/dashboard/shortcode/subscription-status', icon: Search },
      { label: 'Help replies', path: '/dashboard/configuration/help-message', icon: MessageSquare },
      { label: 'Invalid keyword replies', path: '/dashboard/configuration/invalid-keyword', icon: MessageSquare },
    ],
  },
  {
    heading: 'Tools',
    items: [
      { label: 'Partner webhook check', path: '/dashboard/partner-checker', icon: CheckCircle },
      { label: 'UAT test runs', path: '/dashboard/uat-test-runs', icon: PlayCircle },
      { label: 'Telco callback check', path: '/dashboard/api-checker', icon: RefreshCw },
      { label: 'Log search', path: '/dashboard/log-tracer', icon: Terminal },
      { label: 'MTN server logs', href: 'http://91.109.117.92:8001/admin/log', icon: Server },
      { label: 'Airtel server logs', href: 'http://78.110.161.243:8001/admin/log', icon: Server },
      { label: 'Airtel PPO sync logs', href: 'http://91.109.117.94:8001/admin/log', icon: Server },
    ],
  },
];

export const PARTNER_NAV = [
  {
    heading: null,
    items: [{ label: 'Overview', path: '/partner/home', icon: Home }],
  },
  {
    heading: 'Reports',
    items: [
      { label: 'Revenue', path: '/partner/report/summarize-report', icon: BarChart2, exact: true },
      { label: 'Revenue by product', path: '/partner/report/report-by-product', icon: Layers },
      { label: 'Subscriptions', path: '/partner/report/subscribers-list', icon: FileText },
      { label: 'Active subscribers', path: '/partner/report/active-list', icon: Users },
      { label: 'Delivery report', path: '/partner/report/delivery', icon: Send, match: '/partner/report/summarize-report/detail' },
      { label: 'Telco events', path: '/partner/report/events', icon: Activity, exact: true },
      { label: 'Sync failures', path: '/partner/report/sync-failures', icon: AlertTriangle },
      { label: 'Exports', path: '/partner/report/events/exports', icon: DownloadCloud },
    ],
  },
  {
    heading: 'Products',
    items: [
      { label: 'Products', path: '/partner/product/product-list', icon: Box },
      { label: 'New product', path: '/partner/product/create-product', icon: PlusSquare },
      { label: 'Send a message', path: '/partner/messages/send-message', icon: MessageSquare },
    ],
  },
  {
    heading: 'Integration guide',
    items: [
      { label: 'USSD menu requests', path: '/partner/notification/ussd-menu-request', icon: BookOpen },
      { label: 'SMS keywords', path: '/partner/notification/sms', icon: BookOpen },
      { label: 'New subscription sync', path: '/partner/notification/sync-subscription', icon: BookOpen },
      { label: 'Renewal sync', path: '/partner/notification/sync-renewal', icon: BookOpen },
      { label: 'Unsubscription sync', path: '/partner/notification/sync-unsubscription', icon: BookOpen },
    ],
  },
];

/** The nav item that best matches the current path (longest prefix wins). */
export function activeItem(nav, pathname) {
  let best = null;
  let bestLen = -1;
  nav.forEach((g) =>
    g.items.forEach((it) => {
      if (!it.path) return;
      const candidates = [it.path, it.match].filter(Boolean);
      candidates.forEach((p) => {
        const hit = it.exact && p === it.path ? pathname === p || pathname === `${p}/` : pathname === p || pathname.startsWith(`${p}/`);
        if (hit && p.length > bestLen) {
          best = it;
          bestLen = p.length;
        }
      });
    })
  );
  return best;
}
